import { connect } from 'react-redux';
import ParticipantHistoryDialog from './ParticipantHistoryDialog';
import {
  classRoomName,
  currentClassRoomId,
  participantsHistory,
  participantsHistoryCount,
} from '../../../../../../../core/selectors/classroom';
import { fetchClassRoomParticipantsHistory } from '../../../../../../../core/actions/classRoom/participants';

const mapStateToProps = (state) => {
  const spaceId = currentClassRoomId(state);
  if (spaceId) {
    return {
      spaceName: classRoomName(state),
      lastEventDate: state.classRoom.lastEventDate,
      participantsHistory: participantsHistory(state, spaceId),
      isFetching: state.classRoom.isFetchingParticipantsHistory,
      hasFetchedAll: state.classRoom.hasFetchedAllParticipantsHistory,
      historyEventDataCount: participantsHistoryCount(state, spaceId),
    };
  }
  return {
    spaceName: '',
    participantsHistory: {},
    isFetching: true,
    hasFetchedAll: false,
    lastEventDate: new Date().toISOString(),
    historyEventDataCount: 0,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchParticipantsHistory: (payload) =>
    dispatch(fetchClassRoomParticipantsHistory(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ParticipantHistoryDialog);
